const settings = [
  ['Mode data', 'Demo + live weather + opsi Strava'],
  ['Preferensi aktivitas', 'Lari, jalan santai, sepeda'],
  ['Fokus edukasi', 'Panas perkotaan, ruang hijau, kualitas udara'],
  ['Notifikasi', 'Aktif untuk rekomendasi waktu & lokasi'],
];

export function AccountPage() {
  return (
    <div className="app-page account-page">
      <header className="app-page__header">
        <div>
          <span className="eyebrow">Akun & Pengaturan</span>
          <h1>Profil pengguna dibuat sederhana namun tetap mendukung pengalaman yang personal.</h1>
        </div>
      </header>

      <div className="dual-panel-grid">
        <section className="compact-panel compact-panel--profile">
          <div className="profile-card">
            <div className="profile-card__avatar">JC</div>
            <div>
              <h3>JakComfort Demo User</h3>
              <p>Explorer warga Jakarta • fokus kenyamanan aktivitas & edukasi iklim</p>
            </div>
          </div>
          <div className="profile-stats">
            <div><strong>12</strong><span>Lokasi dijelajahi</span></div>
            <div><strong>4</strong><span>Story dibuat</span></div>
            <div><strong>3</strong><span>Aksi diikuti</span></div>
          </div>
        </section>

        <section className="compact-panel">
          <div className="compact-panel__header">
            <div>
              <span className="eyebrow">Preferences</span>
              <h3>Pengaturan utama</h3>
            </div>
          </div>
          <div className="settings-list">
            {settings.map(([label, value]) => (
              <div className="settings-row" key={label}>
                <strong>{label}</strong>
                <span>{value}</span>
              </div>
            ))}
          </div>
          <div className="alert-list">
            <div className="alert-item"><span>✓</span><p>Halaman ini dapat dikembangkan untuk login, penyimpanan preferensi, dan sinkronisasi notifikasi.</p></div>
          </div>
        </section>
      </div>
    </div>
  );
}
